import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'
import { isNativeApp } from '../../client'
import { Props } from './types'
import { taboolaPush, useTaboola } from './useTaboola'

const TaboolaDetails = dynamic(() => import('./TaboolaDetails'))

const TaboolaDiv = ({ options, id, pub, suffixId }: Props) => {
  // const currentUrl = useRef<string | null>(null)
  const { showDetails, taboolaPageType, updateWidget } = useTaboola()

  const router = useRouter()

  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (window._taboola && taboolaPageType) {
      //&& currentUrl.current !== router.asPath
      // currentUrl.current = router.asPath
      setTimeout(() => {
        taboolaPush({
          ...options,
        })
        if (isNativeApp()) {
          window._taboola['mobile'] = []
          window._taboola['mobile'].push({
            allow_sdkless_load: false,
            taboola_view_id: new Date().getTime(),
            publisher: pub,
          })
        }
        updateWidget(id, true)
      }, 10)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, pub, options, router.asPath])

  return (
    <>
      {showDetails && <TaboolaDetails options={options} />}
      <div ref={ref} id={id} data-sufix={suffixId} />
    </>
  )
}

export default TaboolaDiv
